module.exports = __webpack_public_path__ + "static/img/user.3d5b937.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/headlines/user.png
// module id = YVQ5
// module chunks = 1